/**
 * web/src/hooks/queries/useMe.ts
 * Returns the authenticated user. 401 → /login redirect (handled by queryClient).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '../../api/me';
import { qk } from '../../lib/queryKeys';

/**
 * Fetches GET /api/me and caches it for the session under `['me']`.
 *
 * @returns the standard React Query result for the Me payload
 * @throws never directly — errors live on `result.error` (ApiClientError on 401)
 * @sideEffects HTTP GET on first observer; React Query reuses cache otherwise
 * @idempotent yes
 */
export function useMe() {
  return useQuery({
    queryKey: qk.me(),
    queryFn: fetchMe,
    staleTime: 60_000, // 1 min — me is stable per session
  });
}
